<template>
  <div>
    <v-text-field v-if="edit" v-model="setup.name" @keyup.enter="save" outline :placeholder="$vuetify.t('$vuetify.setup.setuptitle')"
                  :label="$vuetify.t('$vuetify.setup.setuptitle')" :rules="inputRules"></v-text-field>
    <v-btn color="primary" dark :small="isMobile" mb-3 fixed bottom right fab :title="$vuetify.t('$vuetify.edit_setup')" @click="edit=true" v-if="!edit">
      <v-icon>edit</v-icon>
    </v-btn>
    <v-btn color="primary" dark :small="isMobile" mb-3 fixed bottom right fab :title="$vuetify.t('$vuetify.save')" @click="save" v-else>
      <v-icon>save</v-icon>
    </v-btn>

    <div class="tabs" v-if="setup">
      <v-card class="tab">
        <v-img src="/static/img/setup_fork.png" class="image"></v-img>
        <v-card-title class="headline" v-html="$vuetify.t('$vuetify.fork')">Fork</v-card-title>
        <v-card-text>
          <v-list :class="edit ? 'no-border' : ''" :two-line="edit">
            <v-list-tile v-for="item in setup.forkSetups" :key="item.id">
              <v-list-tile-content>
                <setup-cell :setup-item="item" :edit="edit" type="fork"></setup-cell>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-card-actions v-if="edit">
          <v-spacer></v-spacer>
          <v-btn flat @click="addEmpty('fork')">
            <v-icon>add</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="tab">
        <v-img src="/static/img/setup_shock.png" class="image"></v-img>
        <v-card-title class="headline" v-html="$vuetify.t('$vuetify.shock')">Shock</v-card-title>
        <v-card-text>
          <v-list :class="edit ? 'no-border' : ''" :two-line="edit">
            <v-list-tile v-for="item in setup.shockSetups" :key="item.id">
              <v-list-tile-content>
                <setup-cell :setup-item="item" :edit="edit" type="shock"></setup-cell>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-card-actions v-if="edit">
          <v-spacer></v-spacer>
          <v-btn flat @click="addEmpty('shock')">
            <v-icon>add</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="tab">
        <v-img src="/static/img/setup_misc.png" class="image"></v-img>
        <v-card-title class="headline" v-html="$vuetify.t('$vuetify.misc')">Misc</v-card-title>
        <v-card-text>
          <v-list :class="edit ? 'no-border' : ''" :two-line="edit">
            <v-list-tile v-for="item in setup.miscSetups" :key="item.id">
              <v-list-tile-content>
                <setup-cell :setup-item="item" :edit="edit" type="misc"></setup-cell>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-card-actions v-if="edit">
            <v-spacer></v-spacer>
            <v-btn flat @click="addEmpty('misc')">
              <v-icon>add</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </div>

    <v-dialog v-model="showDeleteDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">{{$vuetify.t('$vuetify.app.dialog.delete_title')}} Setup</v-card-title>

        <v-card-text>
          {{$vuetify.t('$vuetify.app.dialog.delete_start')}} Setup "{{dialogContent}}" {{$vuetify.t('$vuetify.app.dialog.delete_end')}}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn outline flat="flat" @click="showDeleteDialog = false" v-html="$vuetify.t('$vuetify.cancel')">
            Cancel
          </v-btn>

          <v-btn outline flat="flat" @click="clickDeleteDialogOK" v-html="$vuetify.t('$vuetify.ok')">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import SetupItemCell from '../components/SetupItemCell'
  import StringMixinx from '../mixins/StringMixin'
  import {mapActions, mapGetters} from 'vuex';
  import {eventBus} from '../main';

  export default {
    mixins: [StringMixinx],
    name: 'Setup',
    components: {'setup-cell': SetupItemCell},
    data() {
      return {
        edit: false,
        selectedSetup: 'fork',
        isMobile: false,
        setup: null,
        showDeleteDialog: false,
        dialogContent: null,
        inputRules: [
          v => !!v || this.$vuetify.t('$vuetify.errormsg.required'),
          v => v.length >= 3 || this.$vuetify.t('$vuetify.errormsg.minlength')
        ],
      }
    },
    computed: {
      ...mapGetters([]),
    },
    watch: {
      '$route'(to, from) {
        // workaround for copy -> edit
        if (this.$store.state.lastSetup && this.$store.state.lastSetup.id != to.params.setupId) {
          this.edit = false;
        }
        this.loadSetup();
      }
    },
    mounted() {
      this.onResize();
      window.addEventListener('resize', this.onResize, {passive: true});
      this.loadSetup();
      eventBus.$emit('menu-change', {
        menu: [
          {id: 'copy', title: this.$vuetify.t('$vuetify.duplicate_setup'), icon: 'file_copy'},
          {id: 'delete', title: this.$vuetify.t('$vuetify.delete_setup'), icon: 'delete'}
        ]
      })
      eventBus.$on('menu-selected', this.menuSelected.bind(this));
    },
    beforeDestroy() {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, {passive: true})
      }
      eventBus.$emit('menu-change', {menu: []});
      eventBus.$off('menu-selected', this.menuSelected);
    },
    methods: {
      ...mapActions(['updateSetup', 'copySetup', 'deleteSetup']),
      onResize() {
        this.isMobile = window.innerWidth < 900
      },
      menuSelected(e) {
        switch (e) {
          case 'copy': {
            if (this.setup) {
              console.log('copy start');
              this.copySetup({setup: this.setup});
              this.$router.push('' + this.$store.state.lastSetup.id);
              this.edit = true;
              console.log('copy end');
            }
            break;
          }
          case 'delete': {
            this.dialogContent = this.setup.name;
            this.showDeleteDialog = true;
            break;
          }
        }
      },
      loadSetup() {
        var setup = this.$store.getters.setup(this.$route.params.setupId);
        if (setup) {
          this.setup = JSON.parse(JSON.stringify(setup));

          eventBus.$emit('title-change', setup.name);
        }
      },
      addEmpty(type) {
        switch (type) {
          case 'fork': {
            this.setup.forkSetups.push({});
            break;
          }
          case 'shock': {
            this.setup.shockSetups.push({});
            break;
          }
          default: {
            this.setup.miscSetups.push({});
            break;
          }
        }
      },
      save() {
        for (var i = 0; i != this.setup.forkSetups.length;) {
          if (this.isNullOrEmpty(this.setup.forkSetups[i].name) || this.isNullOrEmpty(this.setup.forkSetups[i].value)) {
            this.setup.forkSetups.splice(i, 1);
          } else {
            i++
          }
        }
        for (var i = 0; i != this.setup.shockSetups.length;) {
          if (this.isNullOrEmpty(this.setup.shockSetups[i].name) || this.isNullOrEmpty(this.setup.shockSetups[i].value)) {
            this.setup.shockSetups.splice(i, 1);
          } else {
            i++
          }
        }
        for (var i = 0; i != this.setup.miscSetups.length;) {
          if (this.isNullOrEmpty(this.setup.miscSetups[i].name) || this.isNullOrEmpty(this.setup.miscSetups[i].value)) {
            this.setup.miscSetups.splice(i, 1);
          } else {
            i++
          }
        }
        this.updateSetup({setup: this.setup});
        this.edit = false;
      },
      clickDeleteDialogOK() {
        this.deleteSetup({setupId: this.setup.id});
        this.showDeleteDialog = false;
        this.$router.push('/')
      },
    }
  }
</script>

<style scoped>

  .icon {
    width: 24px;
    margin-bottom: 4px;
  }

  .v-list:not(.no-border) > * {
    border-bottom: 1px solid #e1e1e1;
  }

  @media (min-width: 900px) {
    .tabs {
      display: flex;
      flex-direction: row;
      width: 100%;
    }

    .tabs .tab {
      width: 33%;
      margin: 0 10px;

      display: flex;
      flex-direction: column;
    }

    .tab .image {
      max-height: 110px;
    }

    .tab .v-card__text {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
    }

    .tab .v-card__text .v-list {
      flex-grow: 1;
    }
  }

  .v-btn--bottom:not(.v-btn--absolute) {
    bottom: 35px;
  }

  @media (max-width: 900px) {


    .tabs .tab {
      margin: 0 10px;
      margin-bottom: 30px;

    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Setup.vue